export default "__VITE_ASSET__DUrhuVKV__"